export default __webpack_public_path__ + "static/media/visual_large.b65da775.jpg";